import { CURRENCY_ISO_CODE } from 'constants/common'
import { useCurrency } from 'providers/currency'
import { useCalculatePriceCheckoutQuery } from 'types/graphql-generated'

const getApprox = (calculatedPrices, targetCurrencyIsoCode) => {
  const approxPrice = (calculatedPrices ?? []).find(
    ({ currencyIsoCode }) => currencyIsoCode === targetCurrencyIsoCode
  )
  return approxPrice ? approxPrice.total : null
}

export const useGetCheckoutSummaryData = (amount) => {
  const selectedCurrency = useCurrency()
  const {
    data: priceData,
    isLoading: isPriceLoading,
    refetch: refetchPrice,
    error: errorGetPrice,
    previousData: previousDataCalculated,
  } = useCalculatePriceCheckoutQuery({
    variables: {
      input: {
        checkoutItems: [
          {
            quantity: 1,
            coupon: { amount },
          },
        ],
        currencyIsoCode: selectedCurrency.currencyIsoCode,
      },
    },
  })

  const isUsingDifferentCurrency =
    CURRENCY_ISO_CODE.USD !== selectedCurrency.currencyIsoCode
  const result = {
    isLoading: isPriceLoading,
    error: errorGetPrice,
    refetchPrice,
  }

  const { calculatePriceCheckout } = priceData ?? previousDataCalculated ?? {}
  return {
    ...result,
    couponSummary: {
      __typename: 'CouponSummary',
      originalPrice: calculatePriceCheckout?.totalPrice?.total,
      discount: calculatePriceCheckout?.totalDiscount?.total,
      discountApprox: isUsingDifferentCurrency
        ? getApprox(
            calculatePriceCheckout?.totalDiscount?.calculatedPrices,
            selectedCurrency.currencyIsoCode
          )
        : null,
      discountPercentage: calculatePriceCheckout?.discountPercentage,
      originalPriceApprox: isUsingDifferentCurrency
        ? getApprox(
            calculatePriceCheckout?.totalPrice?.calculatedPrices,
            selectedCurrency.currencyIsoCode
          )
        : null,
      price: calculatePriceCheckout?.priceToPay?.total,
      priceApprox: isUsingDifferentCurrency
        ? getApprox(
            calculatePriceCheckout?.priceToPay?.calculatedPrices,
            selectedCurrency.currencyIsoCode
          )
        : null,
      currencyIsoCode: calculatePriceCheckout?.priceToPay?.currencyIsoCode,
    },
  }
}
